  document.addEventListener('DOMContentLoaded', () => {
    const toggleMenu = document.getElementById('toggle-menu');
    const mobileNav = document.getElementById('mobile-nav');

    if (!toggleMenu || !mobileNav) return;

    const openMenu = () => {
      mobileNav.classList.add('show-nav');
      toggleMenu.setAttribute('aria-expanded', 'true');
    };

    const closeMenu = () => {
      mobileNav.classList.remove('show-nav');
      toggleMenu.setAttribute('aria-expanded', 'false');
    };

    const toggleMobileMenu = (event) => {
      event.stopPropagation();

      if (mobileNav.classList.contains('show-nav')) {
        closeMenu();
      } else {
        openMenu();
      }
    };

    toggleMenu.addEventListener('click', toggleMobileMenu);

    mobileNav.addEventListener('click', (event) => {
      event.stopPropagation();

      const clickedLink = event.target.closest('a');

      if (clickedLink) {
        closeMenu();
      }
    });

    document.addEventListener('click', (event) => {
      const clickInsideMenu = mobileNav.contains(event.target);
      const clickOnToggle = toggleMenu.contains(event.target);

      if (!clickInsideMenu && !clickOnToggle) {
        closeMenu();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMenu();
      }
    });
  });